import {
  Box,
  Collapse,
  Grid2 as Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import RenderCustomerDiscounts from "./RenderCustomerDiscounts";
import RenderAvailableCoupons from "./RenderAvailableCoupons";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { useEffect, useRef, useState } from "react";

const RenderDiscounts = ({
  discountPage,
  setDiscountPage,
  table,
  customerSelectedRow,
  setSelectedRow,
}) => {
  const lastStableIdRef = useRef(customerSelectedRow?.id || null);
  if (
    customerSelectedRow?.id &&
    lastStableIdRef.current !== customerSelectedRow.id
  ) {
    lastStableIdRef.current = customerSelectedRow.id;
  }
  const stableId =
    customerSelectedRow?.id || lastStableIdRef.current || "default";
  const storageKey = `admin:availableCouponsOpen:${stableId}`;

  // Use a ref to track if we've initialized the state to prevent resets
  const hasInitializedRef = useRef(false);
  const [availableCouponsOpen, setAvailableCouponsOpen] = useState(() => {
    if (hasInitializedRef.current) {
      return false; // Don't reset on re-renders
    }
    hasInitializedRef.current = true;
    try {
      const saved = sessionStorage.getItem(storageKey);
      return saved === "true";
    } catch (e) {
      return false;
    }
  });

  // Handle customer changes - restore accordion state for new customer
  const previousStableIdRef = useRef(stableId);
  useEffect(() => {
    if (previousStableIdRef.current !== stableId) {
      // Customer changed, restore their accordion state
      try {
        const saved = sessionStorage.getItem(
          `admin:availableCouponsOpen:${stableId}`,
        );
        setAvailableCouponsOpen(saved === "true");
      } catch (e) {
        setAvailableCouponsOpen(false);
      }
      previousStableIdRef.current = stableId;
    }
  }, [stableId]);

  // Save accordion state to sessionStorage
  useEffect(() => {
    try {
      sessionStorage.setItem(
        `admin:availableCouponsOpen:${stableId}`,
        availableCouponsOpen ? "true" : "false",
      );
    } catch (e) {
      // ignore storage errors
    }
  }, [availableCouponsOpen, stableId]);
  return (
    <>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Box
            sx={{
              mt: 2,

              bgcolor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            }}
            mb={2}
          >
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      Customer's Coupons
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      sx={{
                        p: 0,
                        px: 2,
                      }}
                    >
                      <RenderCustomerDiscounts
                        discountPage={discountPage}
                        setDiscountPage={setDiscountPage}
                        table={table}
                        selectedRow={customerSelectedRow}
                        setSelectedRow={setSelectedRow}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            }}
            mb={2}
          >
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      Available Coupons for Base Plan:{" "}
                      {customerSelectedRow?.tierName}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton
                        onClick={() =>
                          setAvailableCouponsOpen(!availableCouponsOpen)
                        }
                      >
                        {availableCouponsOpen ? (
                          <RemoveCircleIcon color="error" />
                        ) : (
                          <AddCircleIcon color="primary" />
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      sx={{
                        p: 0,
                      }}
                    >
                      <Collapse
                        in={availableCouponsOpen}
                        timeout="auto"
                        unmountOnExit
                      >
                        <RenderAvailableCoupons
                          table={table}
                          selectedBasePlan={customerSelectedRow?.tierName}
                          limits={customerSelectedRow?.limits}
                          rowID={customerSelectedRow?.id}
                          selectedRow={customerSelectedRow}
                          setSelectedRow={setSelectedRow}
                        />
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default RenderDiscounts;
